export const selectInsuranceClientId = (state) =>
  state.insuranceCalculation?.clientId ||
  state.startPage?.clientId ||
  state.startPage?.application?.client?.id;
